import { FilterCondition } from "planning-portal-library/src/lib/core/domain/models/filter-condition";
import { FilterConditionWebEntity } from "./filter-condition-web-entity";
import { Mapper } from "planning-portal-library/src/lib/core/base";

export class FilterConditionWebEntityMapper extends Mapper<
  FilterConditionWebEntity,
  FilterCondition
> {
  mapFrom(param: FilterConditionWebEntity): FilterCondition {
    
    return {
      id: param.id,
      name: param.name,
    };
  }

  mapTo(param: FilterCondition): FilterConditionWebEntity {     
    return {
      id: param.id,
      name: param.name,
    };
  }
}
